import React, { Component } from "react";
import SharedStateContext from "./SharedStateContext";
export default function withSharedStateConsumer(WrappedComponent) {
  return class extends Component {
    render() {
      return (
        <SharedStateContext.Consumer>
          {context => <WrappedComponent context={context} {...this.props} />}
        </SharedStateContext.Consumer>
      );
    }
  };
}
